import type { NoticeCategory } from './types';

export const NOTICE_CATEGORY_LABELS: Record<NoticeCategory, string> = {
  DOCUMENTS: 'Documentos',
  RECORDS: 'Registros',
  FORMS: 'Formulários',
  HOMOLOGATION: 'Homologação',
  NOTIFICATION: 'Notificações',
  PERMISSIONS: 'Permissões',
  POSITIONS: 'Cargos',
  BRANCHES: 'Filiais',
  TRAINING: 'Treinamento',
  TEST: 'Teste',
  TEST_CONTENT: 'Conteúdo de prova',
};

export const getNoticeCategoryLabel = (category: NoticeCategory): string =>
  NOTICE_CATEGORY_LABELS[category] ?? category;
